/** * 模块名称: HighShotMeter.vue - 高拍仪 * 模块说明: * 创建时间: 2022-02-15
11:36 * 模块负责人: lkc * 修改记录: */
<template>
  <div>
    <!-- 头部 -->
    <div class="headBanner">
      <div class="headClass">
        <div class="tit">
          <h1>扫描 识别 转换 输出</h1>
          <h1>一站式解决方案</h1>
        </div>
        <!-- <img src="@/assets/yj_2.png" alt="" /> -->
        <div class="div"></div>
      </div>
    </div>
    <div class="contBox">
      <!-- 产品简介 -->
      <h1>产品简介</h1>
      <p>
        小科智能语音高拍仪是一款专为政府和企事业单位办公设计的智能语音终端设备，可以实现1秒扫描、语音图像识别、教学、语音打字、语音命令、语音上网等功能，使办公提质增效，适用于各类需要大量扫描文档的场景。
      </p>
      <!-- 产品亮点 -->
      <h1>产品亮点</h1>
      <ul class="productList">
        <li v-for="item in list" :key="item.id">
          <div class="imgClass">
            <img :src="item.url" alt="" />
          </div>
          <span>{{ item.tit }}</span>
        </li>
      </ul>
      <!-- 政、企事业单位应用场景全覆盖 -->
      <h1>政、企事业单位应用场景全覆盖</h1>
      <ul class="gpyScenario">
        <li>
          <img src="@/assets/bg.png" alt="" />
          <h2>办公领域</h2>
          <span>扫描文档、单据，自动生成会议记录，快捷回复消息</span>
        </li>
        <li>
          <img src="@/assets/kd.jpg" alt="" />
          <h2>快递领域</h2>
          <span>快捷录入物流单号</span>
        </li>
        <li>
          <img src="@/assets/jy.png" alt="" />
          <h2>教育行业</h2>
          <span>快捷展示学习资料</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { id: 1, url: require('@/assets/gpy1.png'), tit: '语音命令' },
        { id: 2, url: require('@/assets/gpy2.png'), tit: '1秒快速识别' },
        { id: 3, url: require('@/assets/gpy3.png'), tit: '国产化适配' },
        { id: 4, url: require('@/assets/gpy4.png'), tit: 'OCR文字识别' },
        { id: 5, url: require('@/assets/gpy5.png'), tit: '识别后转音频' },
        { id: 6, url: require('@/assets/hyj1.png'), tit: '多语言识别' },
        { id: 7, url: require('@/assets/gpy7.png'), tit: '制作多页PDF' },
        { id: 8, url: require('@/assets/gpy8.png'), tit: '实时语音转文字' },
        { id: 9, url: require('@/assets/gpy9.png'), tit: '强大拍摄功能' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.headBanner {
  background: url('../../assets/gpyBanner.png');
  background-size: 100% 100%;
  .headClass {
    width: 1200px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tit {
      width: 60%;
      color: #fff;
      // color: #000;
      text-align: left;
    }
    .div {
      width: 30%;
    }
  }
}
.contBox {
  padding: 30px;
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  p {
    text-indent: 2em;
    font-size: 20px;
    text-align: left;
  }
  .productList {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    justify-content: space-around;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 30%;
      justify-content: space-around;
      margin-bottom: 40px;
      .imgClass {
        width: 110px;
        height: 110px;
        border: 2px solid #1296db;
        text-align: center;
        line-height: 110px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100px;
        }
      }
    }
  }
  .gpyScenario {
    list-style: none;
    display: flex;
    justify-content: space-around;
    padding: 0;
    li {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 240px;
        height: 200px;
      }
      span {
        width: 240px;
        text-align: left;
      }
      h2 {
        width: 240px;
        text-align: left;
        margin: 10px 0;
      }
    }
  }
}
</style>
